/**
 * Desktop-only sticky ATC bar when qty / ATC / Buy It Now leave the viewport.
 * Shows product thumb, brand, title, price, quantity, ATC, Buy It Now, wishlist.
 */
class PdpStickyAtc extends HTMLElement {
  static DESKTOP_MQ = '(min-width: 1200px)';
  static STICKY_CLASS = 'is-sticky-atc';

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.bar = this.querySelector('.product-operate-OOS.product-operation');
    this.anchor = this.querySelector('[data-pdp-atc-anchor]');
    this.spacer = this.querySelector('[data-pdp-atc-spacer]');

    if (!this.bar || !this.anchor || !this.spacer) return;

    this.mediaQuery = window.matchMedia(PdpStickyAtc.DESKTOP_MQ);
    this.observer = null;
    this.onMediaChange = this.setup.bind(this);

    this.setup();

    if (typeof this.mediaQuery.addEventListener === 'function') {
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    } else if (typeof this.mediaQuery.addListener === 'function') {
      this.mediaQuery.addListener(this.onMediaChange);
    }
  }

  disconnectedCallback() {
    this.teardown();

    if (!this.mediaQuery || !this.onMediaChange) return;

    if (typeof this.mediaQuery.removeEventListener === 'function') {
      this.mediaQuery.removeEventListener('change', this.onMediaChange);
    } else if (typeof this.mediaQuery.removeListener === 'function') {
      this.mediaQuery.removeListener(this.onMediaChange);
    }
  }

  clearSpacer() {
    if (!this.spacer) return;
    this.spacer.style.height = '';
    this.spacer.style.marginTop = '';
    this.spacer.style.marginBottom = '';
  }

  clearFooterClearance() {
    document.body.style.paddingBottom = '';
  }

  updateFooterClearance() {
    if (!this.bar) return;
    document.body.style.paddingBottom = `${this.bar.offsetHeight}px`;
  }

  setSticky(sticky) {
    if (!this.bar || !this.spacer) return;

    const isSticky = this.bar.classList.contains(PdpStickyAtc.STICKY_CLASS);
    if (sticky === isSticky) return;

    if (sticky) {
      const styles = window.getComputedStyle(this.bar);
      const marginTop = parseFloat(styles.marginTop) || 0;
      const marginBottom = parseFloat(styles.marginBottom) || 0;

      this.spacer.style.height = `${this.bar.offsetHeight}px`;
      this.spacer.style.marginTop = marginTop ? `${marginTop}px` : '';
      this.spacer.style.marginBottom = marginBottom ? `${marginBottom}px` : '';
      this.bar.classList.add(PdpStickyAtc.STICKY_CLASS);
      this.updateFooterClearance();
      return;
    }

    this.bar.classList.remove(PdpStickyAtc.STICKY_CLASS);
    this.clearSpacer();
    this.clearFooterClearance();
  }

  teardown() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.setSticky(false);
  }

  setup() {
    this.teardown();
    if (!this.mediaQuery?.matches || !this.anchor) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (!this.mediaQuery.matches) {
          this.setSticky(false);
          return;
        }

        const entry = entries[0];
        if (!entry) return;

        if (!entry.isIntersecting && entry.boundingClientRect.bottom <= 0) {
          this.setSticky(true);
          return;
        }

        if (entry.isIntersecting) {
          this.setSticky(false);
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px'
      }
    );

    this.observer.observe(this.anchor);
  }
}

if (!customElements.get('pdp-sticky-atc')) {
  customElements.define('pdp-sticky-atc', PdpStickyAtc);
}
